<template>
  <div class="training-form view">
    <form v-if="entity" class="row" @submit.prevent="onSave({close: false})">
      <div class="col">

        <form-model-controls :docs="actionDocs" v-model="entity"/>

      </div>
      <div class="col-12 py-5">
        <bottom-tool-bar :can-delete="!!userId" @save="onSave" @delete="onDelete"/>
      </div>
    </form>
    <div v-else class="text-center">
      <img src="/img/loading.svg" alt="loading">
    </div>

    <confirmation-modal v-if="showDirtyModal"
                        :title="$t('Achtung')"
                        @close="cancelNavigation">
      <template v-slot:default>
        {{ $t('Sie haben ungespeicherte Änderungen. Wie wollen Sie fortfahren?') }}
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-danger" @click="dontSave">
          {{ $t('Nicht speichern') }}
        </button>
        <button type="button" class="btn btn-primary" @click="onSave({close:true})">
          {{ $t('Speichern') }}
        </button>
      </template>
    </confirmation-modal>
  </div>
</template>

<script>
import {mapActions} from "vuex";
// Mixins
import ViewDirtyMixin from '@/mixins/view-dirty'
// Components
import ConfirmationModal from "@/components/ConfirmationModal";
import FormModelControls from "@/components/Form/FormModelControls";
import BottomToolBar from "@/components/BottomToolBar";

export default {
  name: "UserForm",
  mixins: [ViewDirtyMixin],
  components: {
    BottomToolBar,
    FormModelControls,
    ConfirmationModal
  },
  props: {
    regionId: {type: String, default: null},
    userId: {type: String, default: null},
  },
  data() {
    return {
      entity: null,
    }
  },
  computed: {
    actionDocs() {
      if (this.userId) {
        return this.$apiData.Users.find(action => action.name === 'modify')
      }

      return this.$apiData.Users.find(action => action.name === 'add')
    }
  },
  created() {
    if (this.userId) {
      this.getUser({id: this.userId})
          .then(training => {
            this.entity = training;
          })
          .catch(this.apiErrorHandler)
    } else {
      this.entity = {
        region_id: this.regionId
      }
    }
  },
  methods: {
    ...mapActions({
      addUser: "Api/Users/add",
      getUser: "Api/Users/get",
      modifyUser: "Api/Users/modify",
      deleteUser: "Api/Users/delete",
    }),
    onSave({close}) {
      if (this.userId) {
        this.modifyUser(this.entity)
            .then(close ? this.saveComplete : this.saveCompleteToast)
            .catch(this.apiErrorHandler);
      } else {
        this.addUser(this.entity)
            .then(close ? this.saveComplete : entity => {
              this.entity = entity;
              this.saveCompleteToast();
              this.$router.replace(['/regions', this.regionId, 'users/edit', entity.id].join('/'))
            })
            .catch(this.apiErrorHandler);
      }
    },
    onDelete() {
      this.deleteUser({id: this.userId})
          .then(this.saveComplete)
          .catch(this.apiErrorHandler);
    }
  }
}
</script>
